// extracted by mini-css-extract-plugin
export default {"preloader":"Preloader_preloader__9hRCr","active":"Preloader_active__5Cw1g","content":"Preloader_content__uPOoi","logo":"Preloader_logo__ITNzd","line":"Preloader_line__V7Wai"};